var _style, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorBlue1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 392.9 43",
    style: {
      enableBackground: "new 0 0 392.9 43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00B1D9;}\n\t.st1{fill:#9CB6B7;}\n\t.st2{fill:#003E4C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000002351685639177952800000010945180776708945823_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.Dotted-lines"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.4,
    y: 17.2,
    className: "st0",
    width: 329.5,
    height: 8.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.9,25.9h-14.4v-8.7h14.4V25.9z M364.2,25.9h-14.4v-8.7h14.4V25.9z M335.5,25.9h-14.4v-8.7h14.4V25.9z  M306.8,25.9h-14.4v-8.7h14.4V25.9z M278.1,25.9h-14.4v-8.7h14.4V25.9z M249.3,25.9h-14.4v-8.7h14.4V25.9z M220.6,25.9h-14.4v-8.7 h14.4V25.9z M191.9,25.9h-14.4v-8.7h14.4V25.9z M163.2,25.9h-14.4v-8.7h14.4V25.9z M134.5,25.9h-14.4v-8.7h14.4V25.9z M105.8,25.9 H91.4v-8.7h14.4V25.9z M77.1,25.9H62.7v-8.7h14.4V25.9z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.9,31.7V4.1H23c1.4-0.1,2.8,0.3,4,0.9c1,0.6,1.8,1.6,2.3,2.7c0.5,1.3,0.8,2.8,0.7,4.2c0.1,1.5-0.3,3-0.9,4.3 c-0.6,1.1-1.5,1.9-2.6,2.4c-1.2,0.5-2.6,0.8-3.9,0.8h-2.7v12.2H14.9z M19.9,15.9h1.9c0.7,0,1.5-0.1,2.1-0.4c0.5-0.3,0.9-0.7,1.1-1.3 c0.2-0.8,0.3-1.5,0.3-2.3c0-0.8-0.1-1.6-0.2-2.4c-0.1-0.6-0.5-1.1-0.9-1.4c-0.7-0.3-1.5-0.5-2.3-0.4h-1.9V15.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.5,39.9c-1.1,0.1-2.1-0.4-2.7-1.3c-0.7-1.2-1-2.7-0.9-4.1v-4.6c0-0.9,0.1-1.9,0.4-2.8c0.2-0.8,0.6-1.4,1.1-2 c0.6-0.5,1.3-0.8,2.1-0.7c0.5,0,1,0.1,1.5,0.3c0.5,0.2,0.9,0.5,1.3,0.9v-7h3.5v21.1h-3.6v-1.1c-0.4,0.4-0.8,0.7-1.3,1 C36.4,39.7,36,39.9,35.5,39.9z M36.8,37.4c0.2,0,0.4,0,0.6-0.1c0.3-0.1,0.5-0.2,0.8-0.4v-9.6c-0.2-0.1-0.4-0.3-0.7-0.4 c-0.2-0.1-0.5-0.1-0.8-0.1c-0.5,0-0.9,0.2-1.1,0.7c-0.2,0.5-0.3,1.1-0.3,1.7v5.6c0,0.5,0,0.9,0.1,1.4c0,0.3,0.2,0.7,0.4,1 C36.1,37.3,36.5,37.5,36.8,37.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorBlue1);
export default __webpack_public_path__ + "static/media/horBlue1.9ccfb49706bab4cdc3a22e4f30835d6f.svg";
export { ForwardRef as ReactComponent };